import { styled, lighten } from "@mui/material/styles";
import { Grid, Button } from "@mui/material";
import { Theme } from "@fullcalendar/react";

export const Container = styled(Grid)(({ theme }) => ({
  marginTop: "10px",
  width: "100%",
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "space-around",
  borderBottom: `1px solid ${lighten(theme.palette.secondary.light, 0.75)}`,
  backgroundColor: "white",

  "&:last-child": {
    borderBottom: "none",
  },
}));

export const Expander = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "isExpanded" && prop !== "expanderBackgroundColor",
})<{ isExpanded: boolean; expanderBackgroundColor?: string }>(
  {
    width: "100%",
    display: "flex",
    alignItems: "center",
    transition: "all .5s ease",
  },
  ({ isExpanded, expanderBackgroundColor, theme }) => ({
    ...(isExpanded && {
      backgroundColor: !!expanderBackgroundColor ? expanderBackgroundColor : theme.palette.background.paper,
    }),
  })
);

export const IconButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "isExpanded",
})<{ isExpanded: boolean }>(
  {
    minWidth: "40px",
    fontSize: "1.5em",

    "& svg": {
      transition: "transform .5s ease",
    },
  },
  ({ isExpanded }) => ({
    ...(isExpanded && { "& svg": { transform: "rotate(90deg)" } }),
  })
);

export const Expanded = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "isExpanded" && prop !== "expandedBackgroundColor",
})<{ isExpanded: boolean; expandedBackgroundColor?: string }>(
  {
    maxHeight: 0,
    overflow: "hidden",
    transition: "all .5s ease",
  },
  ({ isExpanded, expandedBackgroundColor }) => ({
    ...(isExpanded && {
      maxHeight: 1000,
      width: "100%",
      // backgroundColor: "rgb(245, 255,230)", // active class ???
    }),
    ...(expandedBackgroundColor && {
      backgroundColor: expandedBackgroundColor,
    }),
  })
);
